import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { TransportTileListComponent } from './component/transport-tile-list/transport-tile-list.component';
import { TransportListModule as TransportListModuleNeu} from 'src/tmc-yard/common/components/transport-list/transport-list.module'
import { TransportDetailsModule } from 'src/tmc-yard/common/components/transport-details/transport-details.module';
import { TransportCountsComponent } from './component/transport-counts/transport-counts.component';
import { TransportOverviewComponent } from './component/transport-overview/transport-overview.component';

@NgModule({
  declarations: [
    TransportOverviewComponent,
    TransportTileListComponent,
    TransportCountsComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    TransportDetailsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    TransportListModuleNeu
  ],
  exports: [
    TransportOverviewComponent,
    TransportTileListComponent
  ]
})
export class TransportListModule { }
